export const swap = (arr: any[] = [], start: number = 0, end: number = 0): any[] => {
    let result = new Map<number, any>();
    arr.forEach((item, index) => {
        switch (index) {
            case start:
                result.set(index, arr[end]);
                break;
            case end:
                result.set(index, arr[start]);
                break;
            default:
                result.set(index, arr[index]);
                break;
        }
    });
    return Array.from(result.values());
}


export const moveElementByIndex  =<T>(arr: T[] = [], start: number = 0, end: number = 0): T[] => {
    if (start < 0 || start >= arr.length || end < 0 || end >= arr.length) {
        return arr;
    }
    const result = [...arr];
    const [item] = result.splice(start, 1);
    result.splice(end, 0, item);
    return result;
};